import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import Providers from './Providers'
import reportWebVitals from './reportWebVitals'
import { I18nextProvider } from 'react-i18next'
import i18n from 'config/localization/i18n'
import 'slick-carousel/slick/slick.css'
import 'react-phone-input-2/lib/style.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <Providers>
        <App />
      </Providers>
    </I18nextProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
